import { DefaultFetchState } from "./CommonTypes";

export interface GetLocatorPayloadType {
  lengthId?: string;
  typeId?: string;
  skip?: number;
  limit?: number;
}

interface LocatorTypes {
  typeid: string;
  typename: string;
}

interface LocatorLengths {
  lengthid: string;
  length: number;
}

export enum LocatorImageType {
  PHOTO = "photo",
  RENDER = "render",
}

export interface LocatorsDataTypes {
  locatorid: string;
  typeid: string;
  typename: string;
  lengthid: string;
  length: number | null;
  path: string;
  imagetype: LocatorImageType;
}

export interface LocatorReducerType {
  // Locator lengths & types related
  locatorFetchStatus: DefaultFetchState;
  locatorTypes: LocatorTypes[] | null;
  locatorLengths: LocatorLengths[] | null;
  locatorData: LocatorsDataTypes[] | null;

  // Uploading locator image
  locatorUploadStatus: DefaultFetchState;
  uploadedLocatorData: {
    locatorid: string;
    path: string;
    imagetype: LocatorImageType;
  } | null;

  // Adding locator to dataset
  addNewLocatorStatus: DefaultFetchState;
  newLocatorData: any;
  activeLocator: LocatorsDataTypes | null;

  // Updating existing locator
  locatorUpdateStatus: DefaultFetchState;

  locatorFilters: {
    imagetype?: string;
    typeid?: string;
    lengthid?: string;
  };

  locatorsTotalAmount: number;
}
